import { render, staticRenderFns } from "./OrderRequestPayedList.vue?vue&type=template&id=37c54476&scoped=true"
import script from "./OrderRequestPayedList.vue?vue&type=script&lang=js"
export * from "./OrderRequestPayedList.vue?vue&type=script&lang=js"
import style0 from "./OrderRequestPayedList.vue?vue&type=style&index=0&id=37c54476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c54476",
  null
  
)

export default component.exports